export default __webpack_public_path__ + "static/media/loading.6acbeb2d.svg";